export const numberGames = 10; // Количество игр за баллы
